import { RequestUploadFilesMenu } from "@/components/request-upload-files-menu"
import { useRequestFileUpload } from "@/modules/patients/hooks/useRequestFileUpload"
import { FileUploadRequestFragment$key } from "@/modules/patients/services/__generated__/FileUploadRequestFragment.graphql"
import { ContactChannel } from "@/types/__generated__/union-types"

type RequestUploadFilesContainerProps = {
  appointmentId?: string
  contactChannel?: ContactChannel
  isContactChannelVerified?: boolean
  fileUploadRequestRef?: FileUploadRequestFragment$key | null
  isDisabled?: boolean
}

export const RequestUploadFilesContainer = ({
  appointmentId,
  contactChannel,
  isContactChannelVerified,
  fileUploadRequestRef,
  isDisabled,
}: RequestUploadFilesContainerProps) => {
  const { handleSendRequest, isSendingRequest, handleCancelRequest, ...fileUploadRequestData } = useRequestFileUpload({
    appointmentId: appointmentId ?? "",
    fileUploadRequestRef,
  })

  return (
    <RequestUploadFilesMenu
      isDisabled={isDisabled}
      appointmentId={appointmentId}
      contactChannel={contactChannel}
      isContactChannelVerified={isContactChannelVerified}
      isSendingRequest={isSendingRequest}
      onSendRequest={handleSendRequest}
      onCancelRequest={handleCancelRequest}
      {...fileUploadRequestData}
    />
  )
}
